export const COMPANY = {
  name: "GOLDEN CAB TRANSPORT",
  short: "Golden Cab",
  slogan: "L'Excellence du Transport sur Mesure",
  tagline: "Voyagez dans l'élégance et la ponctualité.",
  legalForm: "SASU (Société par Actions Simplifiée Unipersonnelle)",
  capital: "4 500,00 €",
  rcs: "Evry 819 613 522",
  euid: "FR7801.819613522",
  address: "40 Rue des Hauts Fresnais, 91160 Ballainvilliers, France",
  president: "Monsieur Azedine KERROUCHE",
  presidentBirth: "24/11/1983",
  activity: "Transport routier de personnes (< 9 places) et location de voitures avec chauffeur.",
  host: "Namecheap, Inc. — 4600 East Washington Street, Suite 305, Phoenix, AZ 85034, USA",
  hours: "24h/24 — 7j/7",
};

export const IMAGES = {
  heroBg:
    "https://images.unsplash.com/photo-1641503855609-5e28a1ed35a9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHw0fHxwYXJpcyUyMGNoYW1wcyUyMGVseXNlZXMlMjBuaWdodHxlbnwwfHx8fDE3ODY0NjE1OTl8MA&ixlib=rb-4.1.0&q=85",
  sedan:
    "https://images.unsplash.com/photo-1764605206511-7a649d9df63b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBzZWRhbiUyMG5pZ2h0fGVufDB8fHx8MTc4NjQ2MTU5OXww&ixlib=rb-4.1.0&q=85",
  interior:
    "https://images.unsplash.com/photo-1605437241278-c1806d14a4d9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBzZWRhbiUyMGludGVyaW9yJTIwbGVhdGhlcnxlbnwwfHx8fDE3ODY0NjE3OTd8MA&ixlib=rb-4.1.0&q=85",
  airport:
    "https://images.unsplash.com/photo-1655827763440-7905302b75ff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwyfHxjaGF1ZmZldXIlMjBhaXJwb3J0JTIwdHJhbnNmZXIlMjBsdXh1cnklMjBjYXJ8ZW58MHx8fHwxNzg2NDYxNzk3fDA&ixlib=rb-4.1.0&q=85",
  chauffeur:
    "https://images.unsplash.com/photo-1485291571150-772bcfc10da5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwyfHxjaGF1ZmZldXIlMjBsdXh1cnklMjBjYXJ8ZW58MHx8fHwxNzg2NDYxNTk5fDA&ixlib=rb-4.1.0&q=85",
  champagne:
    "https://images.unsplash.com/photo-1580657274234-7339717f4541?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxjaGFtcGFnbmUlMjBnbGFzcyUyMGx1eHVyeXxlbnwwfHx8fDE3ODY0NjE2MTF8MA&ixlib=rb-4.1.0&q=85",
  nightDrive:
    "https://images.unsplash.com/photo-1619599214559-a8005f992c66?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxtZXJjZWRlcyUyMHMlMjBjbGFzcyUyMGJsYWNrJTIwbmlnaHQlMjBjaXR5fGVufDB8fHx8MTc4NjQ2MTc5N3ww&ixlib=rb-4.1.0&q=85",
};

export const VALUES = [
  {
    title: "Chauffeurs Professionnels",
    desc: "Des chauffeurs formés, discrets et costumés, garants d'un service irréprochable et ponctuel.",
    icon: "UserCheck",
  },
  {
    title: "Flotte Haut de Gamme",
    desc: "Berlines, SUV et vans récents, entretenus avec soin et équipés pour votre confort absolu.",
    icon: "Gem",
  },
  {
    title: "Disponibilité 24/7",
    desc: "Une conciergerie de transport joignable à toute heure, chaque jour de l'année.",
    icon: "Clock",
  },
];

export const TESTIMONIALS = [
  { name: "Camille D.", role: "Directrice Marketing", text: "Ponctualité parfaite et véhicule impeccable. Un vrai service haut de gamme pour mes rendez-vous d'affaires." },
  { name: "Thomas L.", role: "Voyageur fréquent", text: "Transfert CDG réservé en 2 minutes, chauffeur en avance, accueil au nom. Je ne prends plus rien d'autre." },
  { name: "Sarah M.", role: "Wedding Planner", text: "Golden Cab a sublimé le transport de nos mariés. Élégance et discrétion au rendez-vous." },
  { name: "Antoine R.", role: "Cadre dirigeant", text: "Le confort du van VIP pour toute l'équipe. Wi-Fi, sièges salon, ponctualité : impeccable." },
];

export const POPULAR_PLACES = [
  "Aéroport Paris-Charles de Gaulle (CDG)",
  "Aéroport Paris-Orly (ORY)",
  "Aéroport Paris-Beauvais (BVA)",
  "Gare de Lyon, Paris",
  "Gare du Nord, Paris",
  "Gare Montparnasse, Paris",
  "Tour Eiffel, Paris",
  "Champs-Élysées, Paris",
  "La Défense, Puteaux",
  "Disneyland Paris, Marne-la-Vallée",
  "Versailles, Château de Versailles",
  "Ballainvilliers, 91160",
];
